import React from "react";
import { normalizeVariant } from "./shipmentsTransformers";

// FUNCIONES AUXILIARES
export const resolveAlertMetrics = ({
  telemetryInfo,
  batteryLevels,
  variant,
  isStandalone,
}) => {
  const normalizedValue = normalizeVariant(variant);

  const warnings = telemetryInfo?.[normalizedValue]?.warnings ?? {};
  const batteryWarnings =
    telemetryInfo?.[normalizedValue]?.batteryWarnings ?? {};

  const lvlRemote = batteryLevels?.[normalizedValue]?.batteryLvlRemote ?? null;
  const lvlContainer =
    batteryLevels?.[normalizedValue]?.batteryLvlContainer ?? null;

  const remoteAvailable = !isStandalone && lvlRemote != null;
  const containerAvailable = !isStandalone && lvlContainer != null;

  return {
    warnings: {
      impact: warnings.warningsImpact ?? 0,
      open: warnings.warningsOpen ?? 0,
      temp: warnings.warningsTemp ?? 0,
      hum: warnings.warningsHum ?? 0,
      batRemote: batteryWarnings.warningsBatteryLvlRemote ?? 0,
      batContainer: batteryWarnings.warningsBatteryLvlContainer ?? 0,
    },
    battery: { lvlRemote, lvlContainer, remoteAvailable, containerAvailable },
  };
};

export const getWarningStatusText = (warningValue) =>
  warningValue > 0 ? "Sí" : "No";

export const getWarningColor = (warningValue, { okColor, badColor }) =>
  warningValue > 0 ? badColor : okColor;

// MODELO DE TARJETAS DE ALERTAS (TEMPERATURA, HUMEDAD, IMPACTO, APERTURA, BATERIA MANDO, BATERIA DATALOGGER)
export const buildAlertsCardsModel = ({
  isStandalone,
  alertParameters,
  getWarningStatusText,
}) => {
  return [
    {
      key: "temp",
      title: "Temperatura",
      value: getWarningStatusText(alertParameters.warningsTemp),
      color: alertParameters.warningsTempColor,
      disabled: false,
    },
    {
      key: "hum",
      title: "Humedad",
      value: isStandalone
        ? "N/D"
        : getWarningStatusText(alertParameters.warningsHum),
      color: isStandalone ? undefined : alertParameters.warningsHumColor,
      disabled: isStandalone,
    },
    {
      key: "impact",
      title: "Impacto",
      value: isStandalone
        ? "N/D"
        : getWarningStatusText(alertParameters.warningsImpact),
      color: isStandalone ? undefined : alertParameters.warningsImpactColor,
      disabled: isStandalone,
    },
    {
      key: "open",
      title: "Apertura",
      value: isStandalone
        ? "N/D"
        : getWarningStatusText(alertParameters.warningsOpen),
      color: isStandalone ? undefined : alertParameters.warningsOpenColor,
      disabled: isStandalone,
    },
  ];
};
